// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8352) return "js/chunk.npm-async-peek-readable.31b2f54b.js";
	if (chunkId === 7834) return "js/chunk.npm-async-strtok3.8b9a1dc7.js";
	if (chunkId === 4477) return "js/chunk.npm-async-file-type.d9df2e4a.js";
	if (chunkId === 8709) return "js/chunk.npm-async-@tokenizer.63abe6bf.js";
	if (chunkId === 4259) return "js/chunk.npm-async-debug.6e741b71.js";
	if (chunkId === 9863) return "js/chunk.npm-async-uint8array-extras.de13b284.js";
	if (chunkId === 945) return "js/chunk.npm-async-token-types.112686d0.js";
	if (chunkId === 2850) return "js/chunk.npm-async-ms.95caea4b.js";
	if (chunkId === 9257) return "js/chunk.npm-async-ieee754.af1528f1.js";
	if (chunkId === 3034) return "js/chunk.npm-async-fflate.89e8178e.js";
	if (chunkId === 4922) return "js/chunk.npm-async-lodash-es.375f0902.js";
	if (chunkId === 9574) return "js/chunk.npm-async-yjs.fd1cabc1.js";
	if (chunkId === 861) return "js/chunk.npm-async-lib0.88f5d939.js";
	if (chunkId === 7102) return "js/chunk.npm-async-@toeverything.cfc3fb93.js";
	if (chunkId === 9895) return "js/chunk.npm-async-nanoid.2c0d04e3.js";
	if (chunkId === 9214) return "js/chunk.npm-async-date-fns.9fd84653.js";
	if (chunkId === 1928) return "js/chunk.npm-async-mdast-util-to-markdown.20eb96f3.js";
	if (chunkId === 4060) return "js/chunk.npm-async-micromark-core-commonmark.b66aa1bd.js";
	if (chunkId === 2561) return "js/chunk.npm-async-micromark.c3672bb6.js";
	if (chunkId === 5550) return "js/chunk.npm-async-minimatch.3bbf111c.js";
	if (chunkId === 7586) return "js/chunk.npm-async-vfile.a9fc4a65.js";
	if (chunkId === 3328) return "js/chunk.npm-async-micromark-extension-math.96a088d5.js";
	if (chunkId === 2653) return "js/chunk.npm-async-micromark-extension-gfm-table.6cc7cabc.js";
	if (chunkId === 1820) return "js/chunk.npm-async-unist-util-visit-parents.d282a30c.js";
	if (chunkId === 7084) return "js/chunk.npm-async-unified.e1d75caa.js";
	if (chunkId === 8224) return "js/chunk.npm-async-micromark-util-subtokenize.169250cd.js";
	if (chunkId === 2371) return "js/chunk.npm-async-mdast-util-find-and-replace.6ab39f82.js";
	if (chunkId === 7789) return "js/chunk.npm-async-zwitch.8cd01d47.js";
	if (chunkId === 4797) return "js/chunk.npm-async-zod.01306e35.js";
	if (chunkId === 1391) return "js/chunk.npm-async-y-protocols.507c7e04.js";
	if (chunkId === 8552) return "js/chunk.npm-async-vfile-message.55605541.js";
	if (chunkId === 696) return "js/chunk.npm-async-unist-util-visit.23d9f74d.js";
	if (chunkId === 5594) return "js/chunk.npm-async-unist-util-stringify-position.ac513bc5.js";
	if (chunkId === 6139) return "js/chunk.npm-async-unist-util-is.4e0e5666.js";
	if (chunkId === 8905) return "js/chunk.npm-async-trough.540c3aac.js";
	if (chunkId === 4202) return "js/chunk.npm-async-remark-stringify.6a903c1b.js";
	if (chunkId === 8176) return "js/chunk.npm-async-remark-parse.9e73b6a4.js";
	if (chunkId === 121) return "js/chunk.npm-async-remark-math.0abbfe8d.js";
	if (chunkId === 4255) return "js/chunk.npm-async-micromark-util-resolve-all.697f6606.js";
	if (chunkId === 6956) return "js/chunk.npm-async-micromark-util-normalize-identifier.1f66cf50.js";
	if (chunkId === 7093) return "js/chunk.npm-async-micromark-util-html-tag-name.0678ade2.js";
	if (chunkId === 5017) return "js/chunk.npm-async-micromark-util-decode-string.3afad4d0.js";
	if (chunkId === 4561) return "js/chunk.npm-async-micromark-util-decode-numeric-character-reference.71bbb514.js";
	if (chunkId === 8397) return "js/chunk.npm-async-micromark-util-combine-extensions.5ab84d52.js";
	if (chunkId === 3791) return "js/chunk.npm-async-micromark-util-classify-character.165e6156.js";
	if (chunkId === 8549) return "js/chunk.npm-async-micromark-util-chunked.fe23cd80.js";
	if (chunkId === 6636) return "js/chunk.npm-async-micromark-util-character.34408cf4.js";
	if (chunkId === 3854) return "js/chunk.npm-async-micromark-factory-whitespace.abd741b6.js";
	if (chunkId === 5361) return "js/chunk.npm-async-micromark-factory-title.e9caceb7.js";
	if (chunkId === 2373) return "js/chunk.npm-async-micromark-factory-space.83e74d17.js";
	if (chunkId === 185) return "js/chunk.npm-async-micromark-factory-label.c315de62.js";
	if (chunkId === 8707) return "js/chunk.npm-async-micromark-factory-destination.20ee3700.js";
	if (chunkId === 6875) return "js/chunk.npm-async-micromark-extension-gfm-task-list-item.2ca44217.js";
	if (chunkId === 3068) return "js/chunk.npm-async-micromark-extension-gfm-strikethrough.56400657.js";
	if (chunkId === 611) return "js/chunk.npm-async-micromark-extension-gfm-footnote.28aedc14.js";
	if (chunkId === 9216) return "js/chunk.npm-async-micromark-extension-gfm-autolink-literal.b3dc1f5a.js";
	if (chunkId === 8124) return "js/chunk.npm-async-mdast-util-to-string.4ea2ded0.js";
	if (chunkId === 6379) return "js/chunk.npm-async-mdast-util-phrasing.1ccdb886.js";
	if (chunkId === 8767) return "js/chunk.npm-async-mdast-util-math.6f1a9d0e.js";
	if (chunkId === 164) return "js/chunk.npm-async-mdast-util-gfm-task-list-item.6251c593.js";
	if (chunkId === 9520) return "js/chunk.npm-async-mdast-util-gfm-table.343f4fa8.js";
	if (chunkId === 1621) return "js/chunk.npm-async-mdast-util-gfm-strikethrough.3feb7861.js";
	if (chunkId === 8692) return "js/chunk.npm-async-mdast-util-gfm-footnote.dce2c2d2.js";
	if (chunkId === 2583) return "js/chunk.npm-async-mdast-util-gfm-autolink-literal.12a45dd0.js";
	if (chunkId === 6889) return "js/chunk.npm-async-mdast-util-from-markdown.38c99331.js";
	if (chunkId === 330) return "js/chunk.npm-async-markdown-table.321e24e3.js";
	if (chunkId === 2995) return "js/chunk.npm-async-longest-streak.480eb02a.js";
	if (chunkId === 9729) return "js/chunk.npm-async-is-plain-obj.9f30edc8.js";
	if (chunkId === 8872) return "js/chunk.npm-async-fractional-indexing.5fe2ffe6.js";
	if (chunkId === 4996) return "js/chunk.npm-async-devlop.7f7b8ae6.js";
	if (chunkId === 882) return "js/chunk.npm-async-decode-named-character-reference.ad91c441.js";
	if (chunkId === 805) return "js/chunk.npm-async-character-entities.fd782711.js";
	if (chunkId === 1682) return "js/chunk.npm-async-ccount.112434ca.js";
	if (chunkId === 1638) return "js/chunk.npm-async-bail.960af736.js";
	if (chunkId === 1344) return "js/chunk.npm-async-lodash.ismatch.07288978.js";
	if (chunkId === 5086) return "js/chunk.npm-async-extend.6b65c985.js";
	if (chunkId === 5659) return "js/chunk.npm-async-brace-expansion.c44fbbbc.js";
	if (chunkId === 6626) return "js/chunk.npm-async-balanced-match.c3f6644e.js";
	if (chunkId === 8203) return "js/chunk.npm-async-@preact.2ebb05e6.js";
	// return url for filenames based on template
	return "js/" + chunkId + "." + "b7c56067" + ".js";
};